<template>
  <div class="contractors-modal-general-table__row contractors-modal-general-table__header">
    <div class="contractors-modal-general-table__cell">
      <span>{{ $t('Contact name') }}</span>
      <span class="ml-4 required">*</span>
    </div>
    <div class="contractors-modal-general-table__cell">
      <span>{{ $t('Email') }}</span>
      <span class="ml-4 required">*</span>
    </div>
    <div class="contractors-modal-general-table__cell">{{ $t('Phone') }}</div>
    <div class="contractors-modal-general-table__cell">{{ $t('Position') }}</div>
    <div class="contractors-modal-general-table__cell" />
  </div>
</template>

<script>
  export default {
    name: 'ContractorsModalGeneralTableHeader',
  };
</script>
